// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Jotai from "jotai";
import * as React from "react";
import * as Core__Option from "@rescript/core/src/Core__Option.bs.js";
import * as Primitive_option from "@rescript/runtime/lib/es6/Primitive_option.js";
import * as JotaiAtoms$OrcaPaymentPage from "../Utilities/JotaiAtoms.bs.js";
import * as ApiEndpoint$OrcaPaymentPage from "../Utilities/ApiEndpoint.bs.js";
import * as CommonHooks$OrcaPaymentPage from "./CommonHooks.bs.js";
import * as PaymentBody$OrcaPaymentPage from "../Utilities/PaymentBody.bs.js";
import * as PaymentUtils$OrcaPaymentPage from "../Utilities/PaymentUtils.bs.js";
import * as PaymentHelpers$OrcaPaymentPage from "../Utilities/PaymentHelpers.bs.js";
import * as EligibilityHelpers$OrcaPaymentPage from "../Utilities/EligibilityHelpers.bs.js";

function useCardEligibility(logger, runEligibilityOpt) {
  let runEligibility = runEligibilityOpt !== undefined ? runEligibilityOpt : true;
  let paymentMethodListValue = Jotai.useAtomValue(PaymentUtils$OrcaPaymentPage.paymentMethodListValue);
  let match = Jotai.useAtomValue(JotaiAtoms$OrcaPaymentPage.keys);
  let publishableKey = match.publishableKey;
  let sdkAuthorization = match.sdkAuthorization;
  let clientSecret = match.clientSecret;
  let customPodUri = Jotai.useAtomValue(JotaiAtoms$OrcaPaymentPage.customPodUri);
  let match$1 = React.useState(() => {});
  let setCardEligibilityError = match$1[1];
  let match$2 = React.useState(() => {});
  let setEligibilitySurchargeDetails = match$2[1];
  let match$3 = React.useState(() => false);
  let setIsEligibilityPending = match$3[1];
  let eligibilityControllerRef = React.useRef(undefined);
  let match$4 = CommonHooks$OrcaPaymentPage.useDebounce(300);
  let cancelEligibilityDebounce = match$4.cancelDebounce;
  let startEligibilityDebounce = match$4.startDebounce;
  let endpoint = ApiEndpoint$OrcaPaymentPage.getApiEndPoint(publishableKey, undefined);
  React.useEffect(() => (() => Core__Option.forEach(eligibilityControllerRef.current, c => {
    c.abort();
  })), []);
  let checkCardEligibility = async cardNumber => await EligibilityHelpers$OrcaPaymentPage.startEligibilityCheck(eligibilityControllerRef, clientSecret, publishableKey, logger, customPodUri, PaymentBody$OrcaPaymentPage.cardPaymentMethodEligibilityBody(cardNumber), sdkAuthorization, endpoint, paymentMethodListValue.should_block_confirm, setIsEligibilityPending, setEligibilitySurchargeDetails, setCardEligibilityError, "Card payment eligibility check failed", (clientSecret, publishableKey, logger, customPodUri, bodyArr, sdkAuthorization, endpoint, signal) => PaymentHelpers$OrcaPaymentPage.fetchPaymentMethodEligibility(clientSecret, publishableKey, logger, customPodUri, bodyArr, Primitive_option.some(sdkAuthorization), endpoint, Primitive_option.some(signal)));
  let resetEligibilityState = () => {
    setCardEligibilityError(param => {});
    setEligibilitySurchargeDetails(param => {});
    setIsEligibilityPending(param => false);
  };
  let triggerOnCardNumberChange = (cardNumber, isCardSupportedAndValid) => {
    if (runEligibility && paymentMethodListValue.sdk_next_action === "eligibility_check") {
      cancelEligibilityDebounce();
      setCardEligibilityError(param => {});
      setEligibilitySurchargeDetails(param => {});
      if (isCardSupportedAndValid) {
        return startEligibilityDebounce(() => {
          checkCardEligibility(cardNumber);
        });
      } else {
        Core__Option.forEach(eligibilityControllerRef.current, c => {
          c.abort();
        });
        eligibilityControllerRef.current = undefined;
        return setIsEligibilityPending(param => false);
      }
    }
  };
  return {
    cardEligibilityError: match$1[0],
    updateCardEligibilityError: error => setCardEligibilityError(param => error),
    eligibilitySurchargeDetails: match$2[0],
    isEligibilityPending: match$3[0],
    triggerOnCardNumberChange: triggerOnCardNumberChange,
    resetEligibilityState: resetEligibilityState
  };
}

export {
  useCardEligibility,
}
/* jotai Not a pure module */
